// -------------  check si le element de panel left exist ---------------- //

function waitForElements() {
    return new Promise(function(resolve) {
        var interval = setInterval(function() {
            var stockistResultItems = document.querySelectorAll('.stockist-result');
            
            
            if (stockistResultItems.length > 0) {
                clearInterval(interval);
                resolve({ stockistResultItems });
            }

        }, 100);
    });
}

function processElements() {
    
    waitForElements().then(function(elements) {
        elements.stockistResultItems.forEach(function(stockistResultItem) {
            var stockistResultImage = stockistResultItem.querySelector('.stockist-result-image');
            var stockistResultFilters = stockistResultItem.querySelector('.stockist-result-filters');
            var stockistResultDetails = stockistResultItem.querySelector('.stockist-result-details');
            var stockistResultAdress = stockistResultItem.querySelector('.stockist-result-address');
            var stockistResultDistance = stockistResultItem.querySelector('.stockist-result-distance .stockist-icon-marker');
            var stockistResultFilterElements = stockistResultItem.querySelectorAll('.stockist-result-filters .stockist-result-filter');
            var stockistResultDirectionsLink = stockistResultItem.querySelector('.stockist-result-directions-link a');
            
            var storeNames = [];
            var storeNamesWithFilter = [];
            var storeNamesWithFilterMultiMarque = [];

            if (stockistResultImage && stockistResultFilters && stockistResultDetails && stockistResultAdress && stockistResultDistance && stockistResultFilterElements) {
                var parentElement = stockistResultFilters.parentNode;
                parentElement.insertBefore(stockistResultImage, stockistResultFilters.nextSibling);
                parentElement.insertBefore(stockistResultDetails, stockistResultAdress.nextSibling);

                var stockistResultName = stockistResultItem.querySelector('.stockist-result-name').textContent;
                storeNames.push(stockistResultName);
                for (var i = 0; i < stockistResultFilterElements.length; i++) {
                    var filterValue = stockistResultFilterElements[i].textContent.trim();
                    if (filterValue === 'Department Stores') {
                        stockistResultDistance.classList.add('blue-marker');
                        storeNamesWithFilter.push(stockistResultName);
                        //stockistResultFilterElements[i].style.display = 'none';
                        break;
                    } else if (filterValue === 'Boutiques') {
                        stockistResultDistance.classList.add('multi-marque-marker');
                        storeNamesWithFilterMultiMarque.push(stockistResultName);
                        //stockistResultFilterElements[i].style.display = 'none';
                        break;
                    }
                }
            }

            if (stockistResultDirectionsLink) {
                stockistResultDirectionsLink.style.opacity= '0';
            }

            var imgs = document.querySelectorAll('.leaflet-marker-icon');
            imgs.forEach(img => {
                var imgTitle = img.getAttribute('title');
                if (storeNames.includes(imgTitle)) {
                    if (storeNamesWithFilter.includes(imgTitle)) {
                        img.src = 'https://cdn.shopify.com/s/files/1/0738/3157/9933/files/boutique-simone-perele.png?v=1684693865';
                    } else if (storeNamesWithFilterMultiMarque.includes(imgTitle)) {
                        img.src = 'https://cdn.shopify.com/s/files/1/0738/3157/9933/files/boutique-multi-marque.png?v=1684694404';
                    }
                }
            });

            

        });
    });
}

processElements();

// function pour appeler le promise 
function waitlocatorloading() {
    
    waitForElements().then(function(elements) {
        
        document.querySelectorAll(".stockist-search-filter-checkbox input").forEach(function(input) {
            input.addEventListener("change", function() {
                var label = this.parentNode;
                if (this.checked) {
                    label.classList.add('checked');
                } else {
                    label.classList.remove('checked');
                }

                setTimeout(function(){
                    processElements()
                },700)

            });
        });

        var mapStorlocator = document.querySelector('.stockist-map.stockist-map-leaflet');
        var divAdded = document.querySelector('.stockist-horizontal .added-div');
        if (!divAdded) {
            var stockistHorizontalItem = document.querySelector('.stockist-horizontal');

            var divSpans = document.createElement('div');
            divSpans.classList.add('added-div');

            var spanSimonePerele = document.createElement('span');
            spanSimonePerele.textContent = 'Department Stores';
            spanSimonePerele.classList.add('simone-perele');
            spanSimonePerele.style.color = '#575347';
            spanSimonePerele.style.marginRight = '10px';
            spanSimonePerele.style.fontFamily = 'Glyphicons Halflings';
            spanSimonePerele.style.before = '\e062';

            var spanMultiMarque = document.createElement('span');
            spanMultiMarque.textContent = 'Boutiques';
            spanMultiMarque.classList.add('multi-marque');
            spanMultiMarque.style.color = '#BFBAAB';
            spanMultiMarque.style.marginRight = '5px';
            spanMultiMarque.style.fontFamily = 'Glyphicons Halflings';
            spanMultiMarque.style.before = '\e062';

            divSpans.appendChild(spanSimonePerele);
            divSpans.appendChild(spanMultiMarque);

            //stockistHorizontalItem.insertAdjacentElement('afterend', divSpans);
            // add navigation bar customer to global navigation bar
            
            if (window.innerWidth <= 768) {
                mapStorlocator.insertAdjacentElement('afterend', divSpans);
            }else{
                stockistHorizontalItem.insertAdjacentElement('afterend', divSpans);
            }
        }

    }); 
}

waitlocatorloading()

// ------------- recherche button input ---------------- //
function searchField() {
    return new Promise(function(resolve) {
      var interval = setInterval(function() {   
      var searchFielda = document.querySelector('.stockist-search-field');
            if(searchFielda) {
                clearInterval(interval);
                resolve({ searchFielda });
            }
      }, 100);
    });
}

// quand on ajoute de text sur le input
searchField().then(function(elements) {
    var searchField = elements.searchFielda;
    searchField.addEventListener('input', function() {
        // click sur le element 
        searchStore().then(function(elements) {
            elements.autocompleteItems.forEach(function(autocompleteItems) {
                elements.autocompleteItems.forEach(function(item) {
                    item.addEventListener("click",function(){
                        waitForElements().then(function(elements) {
                            processElements(elements);
                        });
                    })
                });
            });
        });
    });
});

// ------------- les element de recherche ---------------- //

function searchStore() {
    return new Promise(function(resolve) {
        var interval = setInterval(function() {
            var autocompleteItems = document.querySelectorAll('.stockist-autocomplete-item');

            if (autocompleteItems.length > 0) {
                clearInterval(interval);
                resolve({ autocompleteItems });
            }

        }, 100);
    });
}

setTimeout(function(){
    var stockistAutocomplete = document.querySelector(".stockist-autocomplete");

    stockistAutocomplete.addEventListener('click',function(){
        
        var autocompleteItems = document.querySelectorAll('.stockist-autocomplete-item')
        if (autocompleteItems.length > 0) {

            waitForElements().then(function(elements) {
                processElements(elements);
            });
        
        }

    })
},1000)






// function pour faire le traitement de panel left











